import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import databaseService from '../services/databaseService';
import RichTextEditor from './RichTextEditor';
import { isAuthenticated } from '../services/authService';

const EditPost = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/auth/login');
      return;
    }

    loadPost();
  }, [postId, navigate]);

  const loadPost = async () => {
    try {
      await databaseService.init();
      const postData = await databaseService.getPost(parseInt(postId));
      
      if (postData) {
        setPost({
          ...postData,
          content: postData.content || '',
          title: postData.title || ''
        });
      } else {
        setError('Post not found');
      }
    } catch (error) {
      console.error('Failed to load post:', error);
      setError('Failed to load post');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (postData) => {
    try {
      await databaseService.updatePost(post.id, {
        ...post,
        ...postData,
        updated_at: new Date().toISOString()
      });
      
      navigate('/admin');
    } catch (error) {
      console.error('Failed to save post:', error);
      alert('Failed to save post. Please try again.');
    }
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  if (loading) {
    return <div className="admin-container">Loading post...</div>;
  }

  if (error) {
    return (
      <div className="admin-container">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/admin')} className="btn btn-primary">
            Back to Admin
          </button>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="admin-container">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>Post Not Found</h2>
          <p>The post you're looking for doesn't exist.</p>
          <button onClick={() => navigate('/admin')} className="btn btn-primary">
            Back to Admin
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <RichTextEditor
        initialContent={post.content}
        title={post.title}
        onSave={handleSave}
        onCancel={handleCancel}
        isEditing={true}
      />
    </div>
  );
};

export default EditPost;
